export enum Rules {
    INSTALLMENTS_MAX_RULE_ID = '28f14049-e33f-469f-8db7-a96725cb903e',
    INSTALLMENTS_NOT_FEES_ID = 'd66f6136-d063-49aa-b29a-8634395b4730',
    INSTALLMENTS_PERCENT_FEES_ID = 'bf9dcf98-b6a1-4c26-bd0c-8cff431178de',
    INSTALLMENTS_ID = '5acbe2d4-aa43-4aea-830a-a19b8a0f7466'
  }
